import { createSlice } from '@reduxjs/toolkit';

import { DriversState } from '../../types';

import { DRIVERS_STATE } from '../../constants';

import { setDriverLocations } from './setDriverLocations';
import { resetDriverLocations } from './resetDriverLocations';
import { setSelectedDriverLocation } from './setSelectedDriverLocation';
import { setDriverFuelAssignmentsCards } from './setDriverFuelAssignmentsCards';
import { setDriverFilteredFuelAssignments } from './setDriverFilteredFuelAssignments';
import { setDriverFuelAssignments } from './setDriverFuelAssignments';
import { resetDriverFuelAssignments } from './resetDriverFuelAssignments';
import { setDriverFuelAssignment } from './setDriverFuelAssignment';
import { addDriverFuelAssignment } from './addDriverFuelAssignment';
import { setAddingDriverFuelAssignmentStatus } from './setAddingDriverFuelAssignmentStatus';
import { setSelectedDriverFuelAssignment } from './setSelectedDriverFuelAssignment';
import { deleteDriverFuelAssignment } from './deleteDriverFuelAssignment';
import { setDeletingDriverFuelAssignmentStatus } from './setDeletingDriverFuelAssignmentStatus';

const initialState: DriversState = {
  locations: {},
  fuelAssignmentsCards: {},
  filteredFuelAssignments: {},
  fuelAssignments: {},
  fuelAssignment: {}
}

export const driversSlice = createSlice({
  name: DRIVERS_STATE,
  initialState,
  reducers: {
    setSelectedDriverLocation,
    resetDriverLocations,
    resetDriverFuelAssignments,
    setAddingDriverFuelAssignmentStatus,
    setSelectedDriverFuelAssignment,
    setDeletingDriverFuelAssignmentStatus
  },
  extraReducers: (builder) => {
    setDriverLocations(builder);
    setDriverFuelAssignmentsCards(builder);
    setDriverFilteredFuelAssignments(builder);
    setDriverFuelAssignments(builder);
    setDriverFuelAssignment(builder);
    addDriverFuelAssignment(builder);
    deleteDriverFuelAssignment(builder);
  }
});

export const driversActions = driversSlice.actions;
export const driversReducer = driversSlice.reducer;
